import moment from 'moment';
import { createReducer } from 'typesafe-actions';
import withJobs from '../../_core/job/reducers';
import {
    IBallastStore,
    TBallastRecord,
} from './@types';
import ballastActions, { EBallastConstants, TBallastActions } from './actions';

const defaultState: IBallastStore = {
    _jobs: {},
    currentOperation: undefined,
    records: {
        byIds: {},
        ids: [],
    },
    filters: {
        startDate: moment().subtract(7, 'days').toDate(),
        endDate: moment().add(1, 'day').toDate(),
        shownRecords: 'ALL',
    },
    tableLogs: [],
    tankSpecificOperations: {
        list: [],
        yearMonth: moment().format('YYYY-MM'),
    },
    showVersionAlert: false,
    version: undefined,
    ballastTanks: [],
    selectedBallastTankForTableLogs: '',
};
const ballastReducers = createReducer<IBallastStore, TBallastActions>(
    defaultState
)
    .handleAction(
        ballastActions.document.historySet,
        function historySet(state, action) {
            return {
                ...state,
                records: action.payload.history,
            };
        }
    )
    .handleAction(
        ballastActions.document.setFilter,
        function setFilter(state, action) {
            return {
                ...state,
                filters: action.payload.filters,
            };
        }
    )
	.handleAction(
        ballastActions.document.tableLogsSet,
        function tableLogsSet(state, action) {
            return { ...state, tableLogs: action.payload.logs };
        }
    )
	.handleAction(
        ballastActions.document.tankSpecificBallastTanks,
        function tankSpecificBallastTanks(state, action) {
            return {
                ...state,
                ballastTanks: action.payload.ballastTanks,
            };
        }
    )
	.handleAction(
        ballastActions.document.tankSpecificOperationBallastTankCodeSet,
        function tankSpecificOperationBallastTankCodeSet(state, action) {
            return {
                ...state,
                selectedBallastTankForTableLogs:
                    action.payload.selectedBallastTankForTableLogs,
            };
        }
    );
   
export default withJobs<IBallastStore>(
    EBallastConstants.FEATURE,
    defaultState,
    ballastReducers
);
